import { render, staticRenderFns } from "./ServiceAccordion.vue?vue&type=template&id=05aa57c9&scoped=true"
import script from "./ServiceAccordion.vue?vue&type=script&lang=js"
export * from "./ServiceAccordion.vue?vue&type=script&lang=js"
import style0 from "./ServiceAccordion.vue?vue&type=style&index=0&id=05aa57c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa57c9",
  null
  
)

export default component.exports